export default "__VITE_ASSET__Dk3zQ3CR__"